import { GovAddressKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { PaginateGovAddressRequest, PaginateGovAddressResponse } from "@maven-rest/docs/GovAddress.dto";
import { GovAddressUrl } from "@maven-rest/docs/GovAddress.url";

export function usePaginateGovAddressQuery(
  req: PaginateGovAddressRequest,
  options?: SimpleQueryOptions<PaginateGovAddressResponse, PaginateGovAddressRequest>
) {
  return useBaseQuery({
    queryKey: [GovAddressKey.PaginateGovAddress, req.keyword, req.includeChangedAddress, req.sort, req.page, req.rpp],
    fnOption: { url: GovAddressUrl.paginateGovAddress, request: req },
    ...options,
  });
}
